export default __webpack_public_path__ + "static/media/checked-circle-orange.bc142abb.svg";